/**
 * German UI strings. The site is German-only — there is no translation layer.
 */
export const strings = {
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    close: "Schließen",
    edit: "Bearbeiten",
    delete: "Löschen",
    loading: "Laden...",
    error: "Ein Fehler ist aufgetreten",
    success: "Erfolgreich",
    required: "Pflichtfeld",
    optional: "Optional",
    back: "Zurück",
    next: "Weiter",
    submit: "Absenden",
    or: "oder",
    search: "Suchen",
  },
  auth: {
    login: "Anmelden",
    logout: "Abmelden",
    register: "Registrieren",
    loginTitle: "Anmelden",
    welcomeMessage: "Willkommen bei",
    phoneLogin: "Mit Telefonnummer anmelden",
    phoneNumber: "Telefonnummer",
    sendCode: "Code senden",
    sendingCode: "Sende Code...",
    enterCode: "Geben Sie den Code aus der SMS ein",
    verifyCode: "6-stelliger Code",
    verifying: "Überprüfe...",
    resendCode: "Code erneut senden",
    loginSuccess: "Erfolgreich angemeldet!",
    redirecting: "Sie werden weitergeleitet...",
    googleLogin: "Mit Google anmelden",
    microsoftLogin: "Mit Microsoft anmelden",
    termsAccept: "Mit der Anmeldung akzeptieren Sie unsere",
    terms: "AGB",
    privacyPolicy: "Datenschutzrichtlinie",
    and: "und",
    accountDeactivated: "Konto deaktiviert",
    accountDeactivatedMessage:
      "Ihr Konto auf oekopunktemarkt.de wurde deaktiviert und ein Zugang ist derzeit nicht möglich. Falls Sie Fragen haben oder der Meinung sind, dass es sich um ein Versehen handelt, kontaktieren Sie uns bitte unter info@oekopunktemarkt.de.",
  },
  profile: {
    title: "Profil",
    subtitle: "Verwalten Sie Ihre Kontoinformationen",
    photo: "Profilbild",
    uploadPhoto: "Bild hochladen",
    changePhoto: "Bild ändern",
    removePhoto: "Bild entfernen",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail-Adresse",
    phone: "Telefonnummer",
    noEmail: "Keine E-Mail-Adresse hinterlegt",
    company: "Unternehmen",
    companyName: "Firmenname",
    companyType: "Unternehmenstyp",
    companyTypeLandowner: "Landbesitzer",
    companyTypeBuyer: "Käufer",
    companyTypeBoth: "Beides",
    address: "Adresse",
    addressLine1: "Straße und Hausnummer",
    addressLine2: "Adresszusatz",
    postalCode: "Postleitzahl",
    city: "Stadt",
    country: "Land",
    language: "Sprache",
    saveChanges: "Änderungen speichern",
    saving: "Speichern...",
    profileUpdated: "Profil erfolgreich aktualisiert",
    profileUpdateError: "Fehler beim Aktualisieren des Profils",
    deleteAccount: "Konto löschen",
    deleteAccountWarning:
      "Diese Aktion kann nicht rückgängig gemacht werden. Alle Ihre Daten werden dauerhaft gelöscht.",
    confirmDelete: "Ja, Konto löschen",
    // Notification settings
    notifications: "Benachrichtigungen",
    notificationsSubtitle: "Wählen Sie, welche E-Mails Sie erhalten möchten",
    emailMatchAlerts: "Match-Benachrichtigungen",
    emailMatchAlertsDesc: "E-Mail, wenn ein neues Angebot zu Ihrer Anfrage passt",
    emailMessageAlerts: "Nachrichten-Benachrichtigungen",
    emailMessageAlertsDesc: "E-Mail, wenn Sie eine neue Nachricht erhalten",
  },
  nav: {
    home: "Startseite",
    offerings: "Angebote",
    aboutUs: "Über uns",
    contact: "Kontakt",
    profile: "Profil",
    myProfile: "Mein Profil",
    myOfferings: "Meine Angebote",
    messages: "Nachrichten",
    requests: "Meine Anfragen",
    myArea: "Mein Bereich",
    myCompany: "Mein Unternehmen",
    myOfferingsDesc: "Ihre Ökopunkte zum Verkauf",
    myRequestsDesc: "Ihre Kaufgesuche",
    deals: "Meine Vorgänge",
    // Product categories
    oekopunkte: "Ökopunkte",
    ausgleichsflaechen: "Ausgleichsflächen",
    landVerpachten: "Land verpachten",
    jagdpacht: "Jagdpacht",
    map: "Karte",
    // Ökopunkte dropdown items (EXACT titles from original oekopunktemarkt.de navigation)
    whatAreOekopunkte: "Was sind Ökopunkte und wie funktioniert ein Ökokonto?",
    buyAndSell: "Tipps zum Kauf und Verkauf von Ökopunkten",
    currentPrice: "Aktueller Preis pro Ökopunkt",
    federalStates: "Bundesländer-Übersicht",
    theSystem: "Das System Ökopunkte",
    // Additional Wissen items (EXACT titles from original oekopunktemarkt.de navigation)
    oekopunkteUmwelt: "Die Bedeutung von Ökopunkten & Ökokonten für die Umwelt",
    kompensationsmassnahmen: "Was sind Kompensationsmaßnahmen?",
    ausgleichsflaechenOekopunkte: "Wie Ausgleichsflächen und Ökopunkte zusammenhängen",
    glossar: "Glossar: Fachbegriffe zu Ökopunkten",
    oekokontoVerordnungen: "Ökokonto-Verordnungen der einzelnen Bundesländern",
    erneuerbareEnergien: "Erneuerbare Energien",
    fuerGemeinden: "Informationen für Gemeinden",
    // Mega menu translations
    megaMenu: {
      landowners: {
        trigger: "Für Landeigentümer",
        profilesTitle: "Ihr Profil",
        landeigentuemer: "Landeigentümer",
        landeigentuemerDesc: "Ungenutztes Land monetarisieren",
        landwirt: "Landwirt",
        landwirtDesc: "Stilllegungsflächen optimal nutzen",
        forstwirt: "Forstwirt",
        forstwirtDesc: "Waldflächen ökologisch aufwerten",
        cta: "Kompensation verkaufen",
        ctaDesc: "Rendite mit ungenutztem Land erzielen",
      },
      developers: {
        trigger: "Für Vorhabenträger",
        profilesTitle: "Ihr Bedarf",
        projektentwickler: "Bauprojekte",
        projektentwicklerDesc: "Immobilienprojekte naturschutzkonform umsetzen",
        kommune: "Öffentliche Vorhaben",
        kommuneDesc: "Kommunale Projekte rechtssicher kompensieren",
        infrastrukturentwickler: "Infrastruktur & Netz",
        infrastrukturentwicklerDesc: "Straßen, Schienen, Leitungen & Netzausbau",
        eeEntwickler: "Wind & Solar",
        eeEntwicklerDesc: "Wind- und Solarprojekte schnell genehmigen",
        cta: "Kompensation beschaffen",
        ctaDesc: "Schnell, rechtssicher, transparent",
        managedServiceTitle: "Managed Service",
        managedService: "Rundum-Service",
        managedServiceDesc:
          "Wir übernehmen Ihre gesamte Kompensation — für Organisationen mit regelmäßigem Bedarf.",
      },
      wissen: {
        trigger: "Wissen",
        // Topic-based organization
        grundlagen: "Grundlagen",
        praxis: "Praxis & Themen",
      },
    },
    // Federal states
    states: {
      bw: "Baden-Württemberg",
      by: "Bayern",
      be: "Berlin",
      bb: "Brandenburg",
      hb: "Bremen",
      hh: "Hamburg",
      he: "Hessen",
      mv: "Mecklenburg-Vorpommern",
      ni: "Niedersachsen",
      nw: "Nordrhein-Westfalen",
      rp: "Rheinland-Pfalz",
      sl: "Saarland",
      sn: "Sachsen",
      st: "Sachsen-Anhalt",
      sh: "Schleswig-Holstein",
      th: "Thüringen",
    },
    // Header CTA (logged-out users)
    headerCta: {
      demandSide: "Kompensation beschaffen",
      supplySide: "Kompensation verkaufen",
      neutral: "Kostenlos registrieren",
    },
  },
  header: {
    openMenu: "Menü öffnen",
    closeMenu: "Menü schließen",
  },
  wizard: {
    createOffering: "Neues Angebot erstellen",
    steps: {
      type: "Art wählen",
      location: "Standort",
      details: "Details",
      review: "Überprüfen",
    },
    typeSelection: {
      title: "Art des Angebots",
      description: "Welche Art von Angebot möchten Sie erstellen?",
    },
    location: {
      title: "Standort auswählen",
      titleLabel: "Titel des Angebots",
      titlePlaceholder: "z.B. Ökopunkte aus Streuobstwiese",
      parcelLabel: "Flurstücke auswählen",
      parcelDescription:
        "Suchen Sie nach einer Adresse und klicken Sie auf die Karte, um Ihre Flurstücke auszuwählen.",
      parcelsSelected: "Flurstücke ausgewählt",
      parcelSelected: "Flurstück ausgewählt",
    },
    details: {
      description: "Beschreibung",
      descriptionPlaceholder: "Beschreiben Sie Ihr Angebot...",
      pointsAvailable: "Verfügbare Ökopunkte",
      pointsPlaceholder: "z.B. 50000",
      pricePerPoint: "Preis pro Punkt (€)",
      pricePlaceholder: "z.B. 0.50",
      leaseType: "Pachtart",
      leaseTypePlaceholder: "Bitte wählen",
      leaseTypeSolar: "Solar",
      leaseTypeWind: "Wind",
      leaseTypeAgriculture: "Landwirtschaft",
      leaseTypeOther: "Sonstige",
      termYears: "Laufzeit (Jahre)",
      termPlaceholder: "z.B. 20",
    },
    review: {
      title: "Zusammenfassung",
      description: "Bitte überprüfen Sie Ihre Angaben:",
      parcels: "Flurstücke",
      selected: "ausgewählt",
      federalState: "Bundesland",
      district: "Landkreis",
      area: "Fläche",
      points: "Punkte",
    },
    buttons: {
      cancel: "Abbrechen",
      back: "Zurück",
      next: "Weiter",
      createOffering: "Angebot erstellen",
    },
  },
  parcelSelector: {
    searchPlaceholder: "Adresse oder Ort suchen...",
    showParcels: "Flurstücke anzeigen",
    zoomHint:
      "Zoomen Sie in NRW näher heran (Zoom 15+), um echte Flurstücke aus dem ALKIS-Kataster auszuwählen.",
    zoomHintShort: "Zoom 15+ erforderlich für Flurstück-Auswahl in NRW",
    nrwOnly: "Flurstückdaten sind derzeit nur für NRW verfügbar",
    noParcelFound: "Kein Flurstück an dieser Position gefunden",
    noGeometry: "Flurstück hat keine Geometrie",
    loadError: "Fehler beim Laden des Flurstücks",
    zoomInToSelect: "Bitte zoomen Sie näher heran, um Flurstücke auszuwählen",
    maxParcelsReached: "Maximal {max} Flurstücke können ausgewählt werden",
    parcelsSelected: "Flurstücke ausgewählt",
    parcelSelected: "Flurstück ausgewählt",
    removeAll: "Alle entfernen",
    gemarkung: "Gemarkung",
    flur: "Flur",
    parcelNumber: "Flurstück",
    clickToSelect: "Klicken Sie auf die Karte, um Flurstücke auszuwählen",
  },
  matches: {
    offeringChanged: "Das Angebot wurde geändert",
    priceUpdated: "Der Preis wurde aktualisiert",
    checkAgain: "Erneut prüfen",
    noLongerValid: "Entspricht nicht mehr Ihren Kriterien",
    noLongerValidDetail:
      "Das Angebot wurde geändert und passt nicht mehr zu Ihrer Anfrage. Sie können es trotzdem ansehen.",
    revalidating: "Wird überprüft...",
    stillValid: "Angebot geändert, aber weiterhin passend",
    scoreUpdated: "Bewertung aktualisiert",
    viewAnyway: "Trotzdem ansehen",
  },
  broker: {
    title: "Interesse bekunden",
    subtitle: "Unverbindlich & kostenlos anfragen",
    usps: {
      legal: "Rechtssichere Verträge",
      legalDesc: "Alle Verträge werden rechtlich geprüft",
      anonymous: "Anonymität garantiert",
      anonymousDesc: "Ihre Identität bleibt bis zum Vertragsabschluss geschützt",
      advisory: "Persönliche Beratung",
      advisoryDesc: "Experten unterstützen Sie bei jedem Schritt",
      escrow: "Treuhand-Abwicklung",
      escrowDesc: "Sichere Zahlungsabwicklung über Treuhandkonto",
    },
    form: {
      quantityLabel: "Benötigte Menge",
      quantityPlaceholder: "z.B. 10.000 Punkte",
      timingLabel: "Gewünschter Zeitraum",
      timingPlaceholder: "Wann benötigen Sie die Punkte?",
      timingOptions: {
        immediately: "Sofort",
        threeMonths: "Innerhalb von 3 Monaten",
        sixMonths: "Innerhalb von 6 Monaten",
        flexible: "Flexibel",
      },
      messageLabel: "Ihre Nachricht",
      messagePlaceholder:
        "Was ist Ihnen besonders wichtig? (Optional: Besondere Anforderungen, Fragen...)",
      submit: "Kostenlose Anfrage starten",
      submitting: "Anfrage wird gesendet...",
    },
    success: {
      title: "Anfrage gesendet!",
      message:
        "Vielen Dank für Ihre Anfrage. Wir prüfen das Angebot und melden uns innerhalb von 24 Stunden bei Ihnen.",
      nextSteps:
        "Sie erhalten eine Bestätigung per E-Mail. Unser Team wird Sie kontaktieren, um die Details zu besprechen.",
    },
    guarantee: {
      title: "Ökopunktemarkt Garantie",
      verified: "Geprüftes Angebot",
      legal: "Rechtssichere Abwicklung",
      escrow: "Treuhand-Service",
      contact: "Persönlicher Ansprechpartner",
    },
    partner: "Ökopunktemarkt (Vermittler)",
    anonymousSeller: "Verifizierter Anbieter",
    anonymousBuyer: "Geprüfter Interessent",
  },
  consent: {
    bannerTitle: "Cookie-Einstellungen",
    bannerDescription:
      "Wir verwenden Cookies, um Ihnen das beste Erlebnis auf unserer Website zu bieten. Einige Cookies sind technisch notwendig, während andere uns helfen, die Website zu verbessern und Ihnen personalisierte Inhalte anzuzeigen.",
    acceptAll: "Alle akzeptieren",
    acceptNecessary: "Nur notwendige",
    manageSettings: "Einstellungen verwalten",
    saveSettings: "Einstellungen speichern",
    categories: {
      necessary: "Notwendige Cookies",
      necessaryDescription:
        "Diese Cookies sind für das Funktionieren der Website erforderlich und können nicht deaktiviert werden. Sie werden in der Regel nur als Reaktion auf von Ihnen vorgenommene Aktionen gesetzt, z.B. Anmeldung oder Ausfüllen von Formularen.",
      analytics: "Analyse-Cookies",
      analyticsDescription:
        "Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren, indem sie Informationen anonym sammeln und melden. Dies hilft uns, die Website zu verbessern.",
      marketing: "Marketing-Cookies",
      marketingDescription:
        "Diese Cookies werden verwendet, um Besuchern relevante Werbung und Marketingkampagnen anzuzeigen. Sie verfolgen Besucher über Websites hinweg.",
    },
    settingsTitle: "Cookie-Einstellungen verwalten",
    privacyPolicy: "Datenschutzerklärung",
    alwaysActive: "Immer aktiv",
  },
  footer: {
    companyDescription:
      "Der Marktplatz für Ökopunkte und naturschutzrechtliche Kompensation in Deutschland. Wir verbinden Landeigentümer mit Vorhabenträgern.",
    madeInGermany: "Made in Germany",
    sinceYear: "Seit 2019",
    forLandowners: "Für Landeigentümer",
    forDevelopers: "Für Vorhabenträger",
    forCompanies: "Für Unternehmen",
    forCompaniesDesc: "Managed Service",
    company: "Unternehmen",
    sellEcoPoints: "Kompensation verkaufen",
    procureCompensation: "Kompensation beschaffen",
    knowledge: "Wissen",
    legalNotice: "Impressum",
    privacyPolicy: "Datenschutz",
    termsAndConditions: "AGB",
  },
  chat: {
    widgetLabel: "Chat öffnen",
    placeholder: "Ihre Frage...",
    send: "Senden",
    minimize: "Minimieren",
    greeting:
      "Guten Tag! Ich bin Klara, Ihre digitale Beraterin für Kompensation: Ökopunkte, Ersatz- und Erstaufforstung, Artenschutz und Sonderbiotope. Wie kann ich Ihnen weiterhelfen?",
    quickSell: "Kompensation verkaufen",
    quickBuy: "Kompensation beschaffen",
    quickLearn: "Was sind Ökopunkte?",
    authRequired: "Für diese Aktion können Sie sich kostenfrei und unverbindlich registrieren.",
    reset: "Neuen Chat starten",
    close: "Schließen",
    invitationTitle: "Fragen zur Kompensation?",
    invitationBody: "Ich helfe Ihnen kostenfrei und unverbindlich weiter.",
    invitationCta: "Jetzt chatten",
    contextualCta: "Klara kann helfen",
    contextualFallback: "Kann ich Ihnen helfen?",
  },
} as const;
